import { ColumnLabel } from '../../../shared/models/ColumnLabel';
import { Link, useNavigation } from 'react-router';
import Spinner from '@rio-cloud/rio-uikit/components/spinner/Spinner';
import { createSearchParams } from '../../../shared/utils/utilsStrings';
import { IConnectionEngagement } from '../models/IConnectionEngagement';
import { IExtractQueryParams } from '../../../shared/models/IExtractQueryParams';

type TableRowContentProps = {
  row: any;
  index: number;
  columns: string[];
  columnLabels: ColumnLabel;
  currentExtractLinkIndex: any;
  setCurrentExtractLinkIndex: any;
  queryParams: IExtractQueryParams
};

const TableRowContent = (props: TableRowContentProps) => {
  const {row, index, columns, columnLabels, currentExtractLinkIndex, setCurrentExtractLinkIndex, queryParams} = props;
  const navigation = useNavigation();
  return (
    <tr className='compactRow'>
      {columns.map(col => {
        if ('extractLink' == col) {
          return (
            <td key={col} data-field={columnLabels[col]} >
              <span className='display-flex align-items-center gap-10' >
                {(navigation.state === 'loading' && currentExtractLinkIndex === index) && (
                  <div>
                    <Spinner />
                  </div>
                )}
                <Link
                  to={{ search: createSearchParams({ asset_id: queryParams.assetId, month: queryParams.month.toString(), year: queryParams.year.toString() }) }}
                  onClick={() => {
                    setCurrentExtractLinkIndex(index);
                  }}>Acessar Extrato
                </Link>
              </span>
            </td>
          )
        }

        if(['activeServices', 'relationshipTime'].includes(col)){
          return (
            <td key={col} className='text-size-14' data-field={columnLabels[col]}>
              <div
                  style={{ minWidth: 90, textTransform: 'capitalize' }}
                  className={row[col as keyof IConnectionEngagement] <= 1 ? 'label label-danger' : 'label label-success'}
              >
                {row[col as keyof IConnectionEngagement]}
                {row[col as keyof IConnectionEngagement] > 0 ? ' Pontos' : ' Ponto'}
              </div>
            </td>
          );
        }

        return (
          <td key={col} className='text-size-14' data-field={columnLabels[col]}>
            <span>{row[col as keyof IConnectionEngagement]}</span>
          </td>
        );
      })}
    </tr>
  );
};

export default TableRowContent;